import Card from 'reactstrap/lib/Card';
export default Card;
//# sourceMappingURL=Card.js.map